module.exports = __webpack_public_path__ + "img/vol01_cup01_cover04.fd31c209.jpg";